/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import InputFormItem from '../../components/InputFormItem/index.tsx';

import {Button} from 'antd';
import {recordProxy} from '../../util';
import './appeal.less';
const Step1 = (props) => {
    const {
        updateAppeal,
        appealData,
        searchFn
    } = props;
    async function nextClick() {
        recordProxy('report-feedback_nextStep', 'click', appealData.phone);
        if (!appealData.phone) {
            updateAppeal({
                phoneErr: '不能为空'
            });
            return;
        }
        searchFn(appealData);
    }

    return (
        <div className="step-1">
            <InputFormItem
                placeholder="请输入要申诉的号码"
                type="phone"
                data={appealData}
                updateData={updateAppeal}
                isMsgRequired={true}
            />
            <Button type="primary"
                className="btn-step1"
                onClick={nextClick}>下一步</Button>
        </div>
    );
};

Step1.propTypes = {
    searchFn: PropTypes.func,
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchAppealSearch: PropTypes.func
};

export default withRouter(Step1);
